/**
 * What a contact's call history says about whether to dial it again (ENG-5),
 * kept on the ProspectQueue record (call_history) so dial eligibility no
 * longer depends on which calls the browser happened to load (the call list
 * is paged and capped). One rule, used by the server that maintains the
 * projection and by the front that reads it; dialRules.canCall is unchanged.
 *
 * The « last call » of a phone number is its newest call by created_date,
 * the first one met on a tie, ignoring the lines the dialer hung up itself
 * because another prospect answered first (outcome 'interrupted').
 */
export const INTERRUPTED_CALL_OUTCOME = 'interrupted';
const iso = (v) => {
    if (!v)
        return null;
    const d = v instanceof Date ? v : new Date(v);
    return Number.isNaN(d.getTime()) ? null : d.toISOString();
};
const counts = (c) => !!c.prospect_phone && c.call_outcome !== INTERRUPTED_CALL_OUTCOME;
/** The last call among `calls` (one phone number's calls, any order). */
export function latestCall(calls) {
    let best = null;
    for (const c of calls) {
        if (!counts(c))
            continue;
        if (!best || new Date(c.created_date ?? '') > new Date(best.created_date ?? ''))
            best = c;
    }
    return best;
}
export function projectCalls(calls) {
    const last = latestCall(calls);
    return {
        last_call_at: iso(last?.created_date),
        last_call_outcome: last?.call_outcome ?? null,
        last_call_status: last?.call_status ?? null,
        meeting_booked: last?.meeting_booked === true,
        attempt_count: calls.filter(counts).length,
        next_follow_up_at: last?.call_outcome === 'callback_requested' ? iso(last.follow_up_at) : null,
    };
}
/**
 * The call dialRules.canCall reasons about, rebuilt from a contact's
 * projection; undefined when the contact has none yet (not backfilled):
 * the caller then falls back to the calls it loaded.
 */
export function lastCallFromProjection(p) {
    if (!p || p.last_call_at === undefined)
        return undefined;
    if (p.last_call_at === null)
        return null;
    return {
        call_outcome: p.last_call_outcome ?? null,
        call_status: p.last_call_status ?? null,
        meeting_booked: p.meeting_booked === true,
        created_date: p.last_call_at,
    };
}
//# sourceMappingURL=prospect-call-projection.js.map